import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Disclaimer.css';

export default function Disclaimer() {
  return (
    <div className="disclaimer-page">
      <Helmet>
        <title>Disclaimer — DhanAcademy</title>
        <meta name="description" content="DhanAcademy disclaimer — educational content only, not financial advice." />
      </Helmet>

      <div className="disclaimer-inner">
        <h1 className="disclaimer-title">Disclaimer</h1>

        <div className="disclaimer-section">
          <h2>Educational Purpose Only</h2>
          <p>
            All content on DhanAcademy — including articles, glossary definitions, calculators,
            and any other material — is provided strictly for educational and informational purposes.
            Nothing on this website constitutes financial advice, investment advice, tax advice,
            or any other form of professional advice.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Not a SEBI-Registered Advisor</h2>
          <p>
            DhanAcademy is not a SEBI-registered investment advisor, research analyst, or portfolio
            manager. We do not recommend specific stocks, mutual funds, or financial products. Any
            mention of specific companies, funds, or financial instruments is purely for educational
            illustration and does not constitute a recommendation to buy, sell, or hold.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Do Your Own Research</h2>
          <p>
            Before making any investment or financial decision, you should conduct your own research
            and due diligence. Consider your personal financial situation, risk tolerance, and
            investment objectives. What works for one person may not be suitable for another.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Past Performance</h2>
          <p>
            Past performance of any investment, index, or financial product is not indicative of
            future results. Returns mentioned in examples and calculations are hypothetical or
            historical and may not reflect actual future performance. Markets are inherently
            unpredictable.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Data Accuracy</h2>
          <p>
            While we strive to keep information accurate and up to date, DhanAcademy does not
            guarantee the accuracy, completeness, or timeliness of any content. Financial
            regulations, tax laws, interest rates, and market conditions change frequently.
            Always verify information with official sources.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>No Liability</h2>
          <p>
            DhanAcademy and its contributors shall not be held liable for any losses, damages,
            or consequences arising from the use of information provided on this website. You
            are solely responsible for your investment and financial decisions.
          </p>
        </div>

        <div className="disclaimer-section">
          <h2>Consult a Professional</h2>
          <p>
            For personalized financial advice, please consult a SEBI-registered investment advisor,
            a qualified chartered accountant, or an appropriate financial professional. Professional
            advisors can evaluate your specific circumstances and provide tailored recommendations.
          </p>
        </div>
      </div>
    </div>
  );
}
